import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

export const optInEligibilityStatusSchema = t.union(
  t.literal('AVAILABLE'),
  t.literal('NOT_ELIGIBLE'),
  t.literal('OPTED_IN'),
  t.literal('OPTED_OUT')
);

export type OptInEligibilityStatus = t.SchemaType<
  typeof optInEligibilityStatusSchema
>;

export const optInTargetStatusSchema = t.union(
  t.literal('OPTED_IN'),
  t.literal('OPTED_OUT')
);

export type OptInTargetStatus = t.SchemaType<typeof optInTargetStatusSchema>;

export const changeOptInErrorReasonSchema = t.union(
  t.literal('NOT_ELIGIBLE'),
  t.literal('PORTAL_ID_NOT_FOUND'),
  t.literal('BACKEND_FAILURE')
);

export type ChangeOptInErrorReason = t.SchemaType<
  typeof changeOptInErrorReasonSchema
>;

const personalisedNavOptInStatus = defineMessage({
  type: 'personalised-nav-opt-in-status' as const,
  payloadSchema: t.object({
    status: optInEligibilityStatusSchema,
  }),
});

const getPersonalisedNavOptInStatus = defineMessage({
  type: 'get-personalised-nav-opt-in-status' as const,
  payloadSchema: t.object({
    forceRefresh: t.optional(t.boolean),
  }),
  reply: personalisedNavOptInStatus,
});

const personalisedNavOptInStatusChangeResult = defineMessage({
  type: 'personalised-nav-opt-in-status-change-result' as const,
  payloadSchema: t.union(
    t.object({
      result: t.literal('SUCCESS'),
      status: optInTargetStatusSchema,
    }),
    t.object({
      result: t.literal('NO_CHANGE'),
      status: optInTargetStatusSchema,
    }),
    t.object({
      result: t.literal('ERROR'),
      reason: changeOptInErrorReasonSchema,
    })
  ),
});

const changePersonalisedNavOptInStatus = defineMessage({
  type: 'change-personalised-nav-opt-in-status' as const,
  payloadSchema: t.object({
    source: t.optional(t.string), // Who is requesting the change
    nextStatus: optInTargetStatusSchema,
  }),
  reply: personalisedNavOptInStatusChangeResult,
});

export const personalisedNavOptInControls = {
  getPersonalisedNavOptInStatus,
  personalisedNavOptInStatus,
  changePersonalisedNavOptInStatus,
  personalisedNavOptInStatusChangeResult,
} as const;
